// extracted by mini-css-extract-plugin
module.exports = {"pageHeader":"Stock_pageHeader__CVo9u"};